var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollarSigninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.063 25.039"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 978",
    d: "M6.595 10.516a2 2 0 111.869-2.54.767.767 0 00.749.536h2.461a.816.816 0 00.8-.954 6.029 6.029 0 00-3.928-4.685V1.3a.8.8 0 00-.8-.8H5.341a.8.8 0 00-.8.8v1.569C1.055 4.115-.98 8.437 1.915 12.586a5.166 5.166 0 004.566 1.932 2 2 0 11-1.869 2.54.767.767 0 00-.749-.536H1.402a.816.816 0 00-.8.954 6.029 6.029 0 003.928 4.685v1.569a.8.8 0 00.8.8h2.405a.8.8 0 00.8-.8v-1.569c3.486-1.246 5.521-5.568 2.626-9.717a5.158 5.158 0 00-4.566-1.928z",
    fill: "currentColor",
    stroke: "#fff"
  })));
}

export default SvgDollarSigninline;